module.exports = __webpack_public_path__ + "media/images/expert__selectedArrow--dark-f18d495bb13c77646837011daaea15a8.png";